import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'antd';

function TransferError({ error = {} }) {
  const validError = Object.keys(error).filter(key => error[key].success === false);
  if (!validError.length) return null;
  return (
    <div className="transfer-error">
      <div className="transfer-error__icon">
        <Icon type="info-circle" />
      </div>
      <div className="transfer-error__context">
        {validError.map(key => (
          <TransferErrorItem key={key} type={key} error={error[key].errors} />
        ))}
      </div>
    </div>
  );
}

function TransferErrorItem({ type, error }) {
  const { t } = useTranslation();

  const errorTitle = {
    partnerCode: 'cms.referral.partner.list.column.partner_code',
    bookingNumber: 'cms.referral.payout.list.column.oppos_no',
    payoutStage: 'cms.referral.payout.list.column.trigger_point',
    currency: 'cms.referral.transfer.list.column.currency',
    balances: 'cms.referral.transfer.editor.error.balances',
    partnerCountry: 'cms.referral.transfer.editor.error.partner_country',
    passportFirstName: 'cms.referral.transfer.list.column.passport_first_name',
    passportLastName: 'cms.referral.transfer.list.column.passport_last_name',
    transferAmount: 'cms.referral.transfer.list.column.amount',
    unknownError: 'cms.referral.transfer.editor.error.label.unknown',
  };
  const errors = Object.keys(error).map(errorName => {
    return t(error[errorName].errorMessage).replace(
      '${name}',
      error[errorName].effectItems.join(', '),
    );
  });
  return (
    <div className="transfer-error__item">
      <label className="transfer-error__sub-title">{t(errorTitle[type])}:</label>
      <div>
        {errors.map(e => (
          <span className="transfer-error__sub-item">{e}</span>
        ))}
      </div>
    </div>
  );
}

export default TransferError;
